import classNames from 'classnames';
import { PropertyWizardContext } from 'context/Context';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { Col, Collapse } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import { getPropertiesForms } from 'redux/propsSlice';
import { getRealEstateData } from 'redux/realEstateSlice';
import { operaciones } from '../OperacionYPropiedad';

export const PropertyData = ({
  setValues,
  values,
  errors,
  touched,
  data,
  realEstate
}) => {
  const { form, types } = useContext(PropertyWizardContext);

  const dispatch = useDispatch();

  const branchOffices = useSelector(
    state => state.realEstate.branchOfficesArray
  );

  useEffect(() => {
    if (values.property_type !== form?.propertyType) {
      if (!data._id) {
        dispatch(getPropertiesForms(values.property_type));
      }
    }
  }, [values.property_type, form?.propertyType]);

  useEffect(() => {
    realEstate?.id && dispatch(getRealEstateData(realEstate.id));
  }, [realEstate]);

  return (
    <>
      <Col xs={12}>
        <label>
          Seleccione la Sucursal que gestionará el inmueble{' '}
          <span className="text-danger">*</span>
        </label>

        <ReactSelect
          name="branch_office_id"
          placeholder="-- Seleccione la Sucursal --"
          options={branchOffices.map(suc => ({
            value: suc.id,
            label: suc.branch_office_name
          }))}
          value={branchOffices
            .map(suc => ({
              value: suc.id,
              label: suc.branch_office_name
            }))
            .find(suc => suc.value === Number(values.branch_office_id))}
          onChange={e => {
            setValues(prev => ({
              ...prev,
              branch_office_id: Number(e.value)
            }));
          }}
          isSearchable={false}
        />

        {errors.branch_office_id && touched.branch_office_id && (
          <label style={{ color: '#da1717e8' }}>
            {errors.branch_office_id}
          </label>
        )}
      </Col>

      <Col xs={12}>
        <label>
          Tipo de Operación
          <span className="text-danger">*</span>
          <small className="text-muted">(Venta, Alquiler, Temporario)</small>
        </label>

        <ReactSelect
          value={operaciones.find(
            operacion => Number(operacion.value) === values.operation_type
          )}
          name="operation_type"
          options={operaciones}
          onChange={e => {
            setValues(prev => ({
              ...prev,
              operation_type: Number(e.value)
            }));
          }}
          placeholder="-- Seleccione la Operación --"
          isSearchable={false}
        />

        {errors.operation_type && touched.operation_type && (
          <label style={{ color: '#da1717e8' }}>{errors.operation_type}</label>
        )}
      </Col>

      <Col xs={12}>
        <label>
          Tipo de Propiedad <span className="text-danger">*</span>{' '}
          <small className="text-muted">
            (Departamento, Casa, Cochera, ...)
          </small>
        </label>

        <ReactSelect
          name="property_type"
          placeholder="-- Seleccione el Tipo de Propiedad --"
          isDisabled={data._id}
          options={types.map(prop => ({
            value: prop.propertyType,
            label: prop.name
          }))}
          value={
            types.find(type => type.propertyType === values.property_type)
              ? {
                  value: values.property_type,
                  label: types.find(
                    type => type.propertyType === values.property_type
                  ).name
                }
              : null
          }
          onChange={e => {
            if (!data._id) {
              setValues({
                ...values,
                property_type: Number(e.value),
                sub_property_type: ''
              });
            }
          }}
          isSearchable={false}
        />

        {errors.property_type && touched.property_type && (
          <label style={{ color: '#da1717e8' }}>{errors.property_type}</label>
        )}

        <h6 className="text-muted mt-2">
          <strong>¡Atención!</strong> Esta característica no{' '}
          {!data._id ? 'podrá modificarse luego.' : 'puede modificarse.'}
        </h6>
      </Col>

      <Col
        xs={12}
        className={classNames({
          'mt-0': !form?.subpropertyTypes
        })}
      >
        <Collapse in={!!form?.subpropertyTypes}>
          <div>
            <label>
              Subtipo de Propiedad <span className="text-danger">*</span>
              <small className="text-Muted"></small>
            </label>

            <ReactSelect
              name="sub_property_type"
              placeholder="-- Seleccione el Subtipo de Propiedad --"
              isDisabled={!form?.subpropertyTypes}
              options={form?.subpropertyTypes?.map(subprop => ({
                value: subprop.id,
                label: subprop.title
              }))}
              value={
                form?.subpropertyTypes?.find(
                  subtype => subtype.id === values.sub_property_type
                )
                  ? {
                      value: values.sub_property_type,
                      label: form?.subpropertyTypes?.find(
                        subtype => subtype.id === values.sub_property_type
                      ).title
                    }
                  : null
              }
              onChange={e => {
                if (form?.subpropertyTypes) {
                  setValues({
                    ...values,
                    sub_property_type: Number(e.value)
                  });
                }
              }}
              isSearchable={false}
            />

            {errors.sub_property_type && touched.sub_property_type && (
              <label style={{ color: '#da1717e8' }}>
                {errors.sub_property_type}
              </label>
            )}

            {!form?.subpropertyTypes && (
              <h6 className="text-muted">
                Este Tipo de Propiedad no tiene Subtipo.
              </h6>
            )}
          </div>
        </Collapse>
      </Col>

      <Col xs={12}>
        <label>
          Título <span className="text-danger">*</span>{' '}
          <small>
            (De una descripción para que se pueda encontrar facilmente)
          </small>
        </label>
        <Field name="title">
          {({ field }) => (
            <input
              type="text"
              {...field}
              className="form-control"
              maxLength="150"
            />
          )}
        </Field>{' '}
        {errors.title && touched.title && (
          <label style={{ color: '#da1717e8' }}>{errors.title}</label>
        )}
      </Col>
    </>
  );
};
PropertyData.propTypes = {
  realEstate: PropTypes.object,
  setValues: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  data: PropTypes.object
};
